import {
  LOGIN_HAS_ERROR,
  LOGIN_IS_LOADING,
  LOGIN, LOGOUT,
  USER_PERMISSIONS
} from '../actions/Actions';

const initialState = {
  hasError: false,
  isLoading: false,
  errorMsg: null,
  timeOut: false,

  permissions: []
};

const loginReducer = (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case LOGIN_HAS_ERROR:
      console.log('haserror', action);

      return {
        ...state,
        hasError: action.hasError,
        errorMsg: action.errorMsg
      };
    case LOGIN_IS_LOADING:
      console.log('isloading', action);

      return { ...state, isLoading: action.isLoading, };
    case USER_PERMISSIONS: {
      console.log('login', action);
      return { ...state, permissions: action.permissions };
    }
    case LOGOUT:
      console.log('logout', action);
      return {
        ...state,
        permissions: [],
        timeOut: action.timeOut ? action.timeOut : false
      };
    default:
      return state;
  }
};

export default loginReducer;
